import { Dispatcher } from "@fanfanlo";
import { initAndroidComponentsI18n } from "../android/components/i18n";

export class AndroidController extends Dispatcher{

    async init(){
        initAndroidComponentsI18n()
    }
}

export const androidController = new AndroidController();